import { render, staticRenderFns } from "./FacebookGetLeadActionSettings.vue?vue&type=template&id=1fdbf788"
import script from "./FacebookGetLeadActionSettings.vue?vue&type=script&lang=js"
export * from "./FacebookGetLeadActionSettings.vue?vue&type=script&lang=js"
import style0 from "./FacebookGetLeadActionSettings.vue?vue&type=style&index=0&id=1fdbf788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports